import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "/api";

const dashboardService = {
  /* SR */
  srActionCounts: async () =>
    (await axios.get(`${API_URL}/dashboard/sr/action-counts`)).data,

  srNextActions: async (limit = 5) =>
    (await axios.get(`${API_URL}/dashboard/sr/next-actions`, { params: { limit } })).data,

  srStaleLeads: async (days = 30) =>
    (await axios.get(`${API_URL}/dashboard/sr/stale-leads`, { params: { days } })).data,

  srFunnel: async ({ from, to } = {}) =>
    (await axios.get(`${API_URL}/dashboard/sr/funnel`, { params: { from, to } })).data,

  srReminderRate: async (days = 30) =>
    (await axios.get(`${API_URL}/dashboard/sr/reminder-rate`, { params: { days } })).data,

  /* SM / Admin */
  smActionCounts: async () =>
    (await axios.get(`${API_URL}/dashboard/sm/action-counts`)).data,

  smRepLeaderboard: async () =>
    (await axios.get(`${API_URL}/dashboard/sm/rep-leaderboard`)).data,

  smSourcePerformance: async () =>
    (await axios.get(`${API_URL}/dashboard/sm/source-performance`)).data,

  smOverdueHeatmap: async (days = 30) =>
    (await axios.get(`${API_URL}/dashboard/sm/overdue-heatmap`, { params: { days } })).data,

  smWeeklyTrend: async (weeks = 4) =>
    (await axios.get(`${API_URL}/dashboard/sm/weekly-trend`, { params: { weeks } })).data,

  smAlerts: async () =>
    (await axios.get(`${API_URL}/dashboard/sm/alerts`)).data,
};

export default dashboardService;